import React from 'react';
import style from './mask.module.scss';

export const Mask = () => (
  <div className="loader">
    <div className={style.loader_overlay} />
  </div>
);
